import styled from "styled-components";
import CustomButton from "../../CustomButton/CustomButton";
import AddchartIcon from "@mui/icons-material/Addchart";
import BalanceIcon from "@mui/icons-material/Balance";

const BodyWrapper = styled.div`
  padding: 20px 20px;
  display: flex;
`;

const Section = styled.div`
  width: ${(props) => props.width};
  display: flex;
  gap: 10px;
  justify-content: ${(props) => props.alignment};
`;

const ModelMarketPlaceToggle = styled.div`
  background: #e7edf2;
  border: 1px solid #b5cadc;
  border-radius: 4px;
  padding: 13px 26px;
  text-align: center;
  color: #004576;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
`;

const DashboardNavigationTool = () => {
  return (
    <BodyWrapper>
      <Section alignment="flex-start" width={"45%"}></Section>
      <Section alignment="center" width={"10%"}>
        <ModelMarketPlaceToggle>MARKETPLACE</ModelMarketPlaceToggle>
      </Section>
      <Section alignment="flex-end" width={"45%"}>
        <CustomButton
          text="CREATE NEW MODEL"
          icon={<AddchartIcon sx={{ marginRight: "10px" }} />}
          isMaterialIcon={true}
        />
        <CustomButton
          text="COMPARE MODELS"
          icon={<BalanceIcon sx={{ marginRight: "10px" }} />}
          isMaterialIcon={true}
        />
      </Section>
    </BodyWrapper>
  );
};

export default DashboardNavigationTool;
